// Hierarchical football positions grouped by category
export const FOOTBALL_POSITION_GROUPS = [
  {
    label: 'Offense',
    positions: [
      'Quarterback', 'Running Back', 'Fullback', 'Wide Receiver', 'Tight End',
      'Offensive Tackle', 'Offensive Guard', 'Center'
    ]
  },
  {
    label: 'Defense',
    positions: [
      'Defensive End', 'Defensive Tackle', 'Nose Tackle',
      'Outside Linebacker', 'Inside Linebacker', 'Middle Linebacker',
      'Cornerback', 'Free Safety', 'Strong Safety'
    ]
  },
  {
    label: 'Special Teams',
    positions: ['Kicker', 'Punter', 'Long Snapper', 'Kick Returner', 'Punt Returner']
  },
  {
    label: 'Other',
    positions: ['Athlete/Utility']
  }
];

// Flat list for backward compatibility
export const SPORT_POSITIONS = {
  Football: FOOTBALL_POSITION_GROUPS.flatMap(g => g.positions),
};

export const SPORTS = Object.keys(SPORT_POSITIONS);
export const DEFAULT_SPORT = 'Football';

// Off-season video label options
export const OFF_SEASON_LABELS = [
  'Training', 'Camp Highlights', 'Workout', '7-on-7', 'Positional Drills', 'Other'
];

// Common US high school sports (ranked roughly by NFHS participation)
export const OTHER_SPORTS = [
  'Baseball',
  'Basketball',
  'Bowling',
  'Cheerleading',
  'Cross Country',
  'Field Hockey',
  'Flag Football',
  'Golf',
  'Gymnastics',
  'Ice Hockey',
  'Lacrosse',
  'Rowing',
  'Rugby',
  'Soccer',
  'Softball',
  'Swimming & Diving',
  'Tennis',
  'Track & Field',
  'Volleyball',
  'Water Polo',
  'Weightlifting',
  'Wrestling',
];
